export const SERVICE_ENDPOINTS = {
  base: '/services',
  import: '/services/import',
  byId: (id: string) => `/services/${id}`,
  entityLinks: (entityId: string) => `/services/links/entity/${entityId}`,
  checkSimilarName: '/services/check-similar-name',
};
